import { Formik, FormikConfig, Form as FormikForm } from 'formik'
import { FC } from 'react'

/**
 * @deprecated this component should not be used, as it provides little value and may circumvent typechecking
 */
export const Form: FC<FormikConfig<any>> = ({ children, ...props }) => (
  <Formik {...props}>
    <FormikForm>{children}</FormikForm>
  </Formik>
)
